export default __webpack_public_path__ + "static/media/selectorlogo.572fddec.jpg";